export const notificationTableHeaders: string[] = [
    'serial_number',
    'tag_id',
    'date',
    'location',
    'message',
    'action',
]
